export type DataLibraryTypeColorKey =
  | 'text'
  | 'number'
  | 'date'
  | 'boolean'
  | 'collection';

const TYPE_KEYS = new Set<DataLibraryTypeColorKey>([
  'text',
  'number',
  'date',
  'boolean',
  'collection',
]);

export const DATA_LIBRARY_TYPE_COLORS: Record<
  DataLibraryTypeColorKey,
  { iconText: string; badge: string }
> = {
  text: {
    iconText: 'text-purple-700',
    badge: 'bg-purple-50 text-purple-700',
  },
  number: {
    iconText: 'text-blue-700',
    badge: 'bg-blue-50 text-blue-700',
  },
  date: {
    iconText: 'text-green-700',
    badge: 'bg-green-50 text-green-700',
  },
  boolean: {
    iconText: 'text-red-700',
    badge: 'bg-red-50 text-red-700',
  },
  collection: {
    iconText: 'text-amber-700',
    badge: 'bg-amber-50 text-amber-700',
  },
};

const NEUTRAL = {
  iconText: 'text-neutral-600',
  badge: 'bg-neutral-50 text-neutral-700',
};

export function dataLibraryTypeKey(
  kind?: string | null,
  valueType?: string | null,
): DataLibraryTypeColorKey | null {
  if (kind === 'collection') {
    return 'collection';
  }
  if (valueType && TYPE_KEYS.has(valueType as DataLibraryTypeColorKey)) {
    return valueType as DataLibraryTypeColorKey;
  }
  return null;
}

export function dataLibraryTypeIconClass(
  key: DataLibraryTypeColorKey | string | null | undefined,
): string {
  if (key && key in DATA_LIBRARY_TYPE_COLORS) {
    return DATA_LIBRARY_TYPE_COLORS[key as DataLibraryTypeColorKey].iconText;
  }
  return NEUTRAL.iconText;
}

export function dataLibraryTypeBadgeClass(
  key: DataLibraryTypeColorKey | string | null | undefined,
): string {
  if (key && key in DATA_LIBRARY_TYPE_COLORS) {
    return DATA_LIBRARY_TYPE_COLORS[key as DataLibraryTypeColorKey].badge;
  }
  return NEUTRAL.badge;
}
